import { FC } from 'react';
import styled from 'styled-components';

import { MpLink } from 'shared/ui/MpLink';
import { MpOl } from 'shared/ui/MpOl';
import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';
import { MpText } from 'shared/ui/MpText';

const ImgStyled = styled.img`
	margin-top: 16px;
	margin-bottom: 12px;
	margin-left: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: 100%;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 450px;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 650px;
	}
`;

const ListStyled = styled(MpOl)`
	gap: 12px;
	margin-bottom: 24px;
`;

export const TrainsInstruction: FC = () => (
	<section>
		<MpPropertyTitle>Установка приложения</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Оформите подписку на&nbsp;пиццерии, рядом с&nbsp;которыми есть&nbsp;ж/д вокзал. Затем перейдите
					в&nbsp;приложение
				</MpText>
			</li>
			<li>
				<MpText>
					Откройте панель управления и&nbsp;пройдите авторизацию. Это&nbsp;может занять
					около&nbsp;10&nbsp;минут
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-1-3x' />
			</li>
		</ListStyled>
		<MpPropertyTitle>Подключение экрана в пиццерии</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Введите адрес <MpLink url='https://trains.sdodo.ru/' text='trains.sdodo.ru' /> в&nbsp;браузере
					телевизора, затем нажмите на&nbsp;кнопку «Авторизовать экран». На&nbsp;экране появится&nbsp;код
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-2' />
			</li>
			<li>
				<MpText>На панели управления выберите пиццерию для подключения</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-3' />
			</li>
			<li>
				<MpText>Введите код с телевизора в открывшемся окне</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-4' />
			</li>
			<li>
				<MpText>Готово! Экран подключён</MpText>
			</li>
		</ListStyled>
	</section>
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TrainsInstruction_eng: FC = () => (
	<section>
		<MpPropertyTitle>Application Installation</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>Subscribe to pizzerias near railway stations. Then go to the application.</MpText>
			</li>
			<li>
				<MpText>Open the control panel and log in. This may take about 10 minutes.</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-1-3x' />
			</li>
		</ListStyled>
		<MpPropertyTitle>Connecting the Screen in the Pizzeria</MpPropertyTitle>
		<ListStyled>
			<li>
				<MpText>
					Enter the address <MpLink url='https://trains.sdodo.ru/' text='trains.sdodo.ru' /> in the browser of
					the television, then click on the &quot;Authorize screen&quot; button. A code will appear on the
					screen.
				</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-2' />
			</li>
			<li>
				<MpText>Select the pizzeria for connection on the control panel</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-3' />
			</li>
			<li>
				<MpText>Enter the code from the TV in the opened window</MpText>
				<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/trains/instruction-4' />
			</li>
			<li>
				<MpText>Done! The screen is connected</MpText>
			</li>
		</ListStyled>
	</section>
);
